
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "34",
    "height": "34",
    "viewBox": "0 0 34 34"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "id": "聊天",
        "class": "cls-1",
        "d": "M17,27.938a10.971,10.971,0,0,1-5.3-1.359,5.716,5.716,0,0,1-1.712,1.037A10.452,10.452,0,0,1,6,27.947a4.116,4.116,0,0,0,1.983-2.18,8.741,8.741,0,0,0,.435-1.948A11,11,0,1,1,17,27.938Z"
      }
    }
  ]
})
    }
  